/**
 * TanStack Query hooks for `published-pentest-results`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	publishedPentestResultsQueryKeys,
	type CreatePublishedPentestResultsBody,
	type ListPublishedPentestResultsResponse,
	type PublishedPentestResultsRow,
} from "./api";

export function usePublishedPentestResultsList(): UseQueryResult<ListPublishedPentestResultsResponse, Error> {
	return useQuery({
		queryKey: publishedPentestResultsQueryKeys.list(),
		queryFn: list,
	});
}

export function usePublishedPentestResultsCreate(): UseMutationResult<PublishedPentestResultsRow, Error, CreatePublishedPentestResultsBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: publishedPentestResultsQueryKeys.all });
		},
	});
}

export function usePublishedPentestResultsDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: publishedPentestResultsQueryKeys.all });
		},
	});
}
